// src/context/AuthContext.js  ←  REPLACE EVERYTHING WITH THIS
import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from "react";
import {jwtDecode} from "jwt-decode";
import axios from "axios";

export const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  /* ------------------------------------------------------------
   * 0️⃣  Helpers
   * ---------------------------------------------------------- */
  const apiBase =
    process.env.REACT_APP_API_URL ||
    "";

  const safeDecode = (raw) => {
    try {
      if (raw && raw.split(".").length === 3) return jwtDecode(raw);
    } catch {
      /* ignore */ /* eslint-disable-line no-empty */
    }
    return null;
  };

  const setAxiosAuth = (tok) => {
    if (tok) axios.defaults.headers.common["Authorization"] = `Bearer ${tok}`;
    else delete axios.defaults.headers.common["Authorization"];
  };

  /* ------------------------------------------------------------
   * 1️⃣  Init state
   * ---------------------------------------------------------- */
  const stored = localStorage.getItem("kodanzaToken");
  const [token, setToken] = useState(stored && safeDecode(stored) ? stored : null);
  const [user, setUser]   = useState(stored ? safeDecode(stored) : null);
  const [loading, setLoading] = useState(true);

  /* keep Axios header in sync */
  useEffect(() => setAxiosAuth(token), [token]);

  /* ------------------------------------------------------------
   * 2️⃣  On first mount, refresh /me (handles cookie sessions)
   * ---------------------------------------------------------- */
  useEffect(() => {
    const hydrate = async () => {
      try {
        const { data } = await axios.get(`${apiBase}/api/me`, {
          withCredentials: true,
        });
        if (data?.token) {
          localStorage.setItem("kodanzaToken", data.token);
          setToken(data.token);
        }
        if (data?.user) setUser(data.user);
      } catch {/* silent fail */} /* eslint-disable-line no-empty */
      finally {
        setLoading(false);
      }
    };
    hydrate();
  }, []); // run once

  /* ------------------------------------------------------------
   * 3️⃣  Auth helpers
   * ---------------------------------------------------------- */
  const login = useCallback((newToken, userObj) => {
    if (!newToken || newToken === "undefined") return;
    localStorage.setItem("kodanzaToken", newToken);
    setToken(newToken);
    setUser(userObj || safeDecode(newToken));
    setAxiosAuth(newToken);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("kodanzaToken");
    setToken(null);
    setUser(null);
    setAxiosAuth(null);
  }, []);

  /* ------------------------------------------------------------
   * 4️⃣  Provider
   * ---------------------------------------------------------- */
  return (
    <AuthContext.Provider value={{ user, token, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
